import DrawerHeader from "./drawer-header";
import DrawerFooter from "./drawer-footer";
import DrawerContent from "./drawer-content";

interface DrawerProps {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
}

const Drawer: React.FC<DrawerProps> = ({ isOpen }) => {
  return (
    <div
      className={`z-[3] transition-all duration-300 overflow-y-scroll fixed top-0 left-0 h-full bg-[#090E20] text-white pt-[32px] pb-[25px] px-[20px] flex flex-col ${
        isOpen ? "w-[250px]" : "w-[85px] !px-[15px]"
      }`}
    >
      <DrawerHeader />
      <DrawerContent isOpen={isOpen} />
      <DrawerFooter isOpen={isOpen} />
    </div>
  );
};

export default Drawer;
